import apiClient from '../utils/apiClient';

const base = (facilityId) => `/api/facilities/${facilityId}/units`;

const unitsService = {
  getAll: (facilityId, params) => apiClient.get(`${base(facilityId)}/`, { params }),
  getById: (facilityId, id) => apiClient.get(`${base(facilityId)}/${id}`),
  create: (facilityId, data) => apiClient.post(`${base(facilityId)}/`, data),
  update: (facilityId, id, data) => apiClient.put(`${base(facilityId)}/${id}`, data),
  delete: (facilityId, id) => apiClient.delete(`${base(facilityId)}/${id}`),
  archive: (facilityId, id) =>
    apiClient.post(`${base(facilityId)}/${id}/archive`),
  unarchive: (facilityId, id) =>
    apiClient.post(`${base(facilityId)}/${id}/unarchive`),
  bulkRateChange: (facilityId, body) =>
    apiClient.post(`${base(facilityId)}/bulk-rate-change`, body),
};

export default unitsService;
